'use strict';

import { view } from '@/functions';

const prefix = '/banks';

export default [
    {
        path: prefix,
        name: 'banks',
        meta: {
            title: 'Banks',
            scopes: ['read_banks', 'write_banks']
        },
        component: () => view('banks/index'),
    },
    {
        path: `${prefix}/info`,
        name: 'banks-info',
        meta: {
            title: 'Banks',
            scopes: ['read_banks', 'write_banks']
        },
        component: () => view('banks/info'),
    },
];

